import { ref, computed } from 'vue'

import type { Props } from '../types'
import type { DisplayModeType } from '@/constants/enums/NotificationPanelDisplayMode'
import type { GetNotificationsResponse } from '@/types/api/customer/Notification'
import type { Ref, ComputedRef } from 'vue'
import type { NotificationMeta } from '@/types/domain/Notification'

import { DisplayMode } from '@/constants/enums/NotificationPanelDisplayMode'
import { useGetNotifications } from '@/composables/api/customer/Notification'

type UseNotification = (
  props: Props,
) => {
  displayMode: Ref<DisplayModeType>
  isUnreadOnlyDisplay: Ref<boolean>
  unreadCount: ComputedRef<number>
  notificationMetaList: ComputedRef<NotificationMeta[]>
  notificationData: Ref<GetNotificationsResponse | undefined>
  getNotifications: () => void
  changeDisplayMode: (mode: DisplayModeType) => void
  toggleUnreadOnlyDisplay: () => void
}

export const useNotification: UseNotification = (
  props,
) => {
  const displayMode = ref<DisplayModeType>(DisplayMode.LIST)
  const isUnreadOnlyDisplay = ref(false)

  const { data: notificationData, refresh: getNotifications } = useGetNotifications(
    computed(() => props.userDisplayMode),
  )

  const notificationMetaList = computed<NotificationMeta[]>(() => {
    return notificationData.value?.notifications || []
  })

  const unreadCount = computed(() => {
    return notificationMetaList.value.filter(notification => !notification.isRead).length
  })

  const changeDisplayMode = (mode: DisplayModeType) => {
    displayMode.value = mode
  }

  const toggleUnreadOnlyDisplay = () => {
    isUnreadOnlyDisplay.value = !isUnreadOnlyDisplay.value
  }

  return {
    displayMode,
    isUnreadOnlyDisplay,
    unreadCount,
    notificationMetaList,
    notificationData,
    getNotifications,
    changeDisplayMode,
    toggleUnreadOnlyDisplay,
  }
}
